import { ff } from '@atlassian/jira-feature-flagging';

export const isStopLoadingFieldConfigTwiceEnabled = () =>
	ff('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
